import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {first} from 'rxjs/operators';
import {UserService} from '../../../../_services';
import {ToastService} from '../../../../_services/toast.service';
import {TranslateService} from '@ngx-translate/core';
import {LoadingService} from '../../../../_services/loading.service';
import {StorageService} from '../../../../_services/storage.service';
import {Roles, User} from '../../../../_model';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-why-account-verification',
  templateUrl: './account-verification.component.html',
  styleUrls: ['./account-verification.component.scss']
})

export class AccountVerificationComponent implements OnInit {
  accountVerificationForm: FormGroup;
  submitted = false;
  userId: string;
  email: string;
  guestUserObj: User;

  constructor(private activatedRoute: ActivatedRoute,
              private authService: UserService,
              public toast: ToastService,
              public translate: TranslateService,
              private spinner: LoadingService,
              private storageService: StorageService,
              public router: Router) {
    this.accountVerificationForm = new FormGroup({
      code: new FormControl('',
        [
          Validators.required
        ])
    });

    this.activatedRoute.queryParams.subscribe((params) => {
      this.userId = params.id;
      this.email = params.email;
    });
  }

  ngOnInit() {
    this.guestUser();
  }

  async guestUser() {
    this.guestUserObj = await this.storageService.get(environment.userObj);
  }

  onSubmit(): void {
    this.submitted = true;
    // stop here if form is invalid
    if (this.accountVerificationForm.invalid) {
      return;
    }

    const code: any = this.accountVerificationForm.value;

    this.spinner.show();
    this.authService.activateAccount(this.userId, code.code)
      .pipe(first())
      .subscribe(
        (userObj) => {
          this.spinner.hide();
          this.toast.display('Account activated successfully, please login');
          delete this.guestUserObj.password;
          this.storageService.set(environment.userObj, this.guestUserObj);
          this.router.navigate(['./user/auth/sign-in'], {queryParams: {role: Roles[this.guestUserObj.roles]}});
        }, (error) => {
          this.spinner.hide();
          console.error('error', error);
          this.toast.error('Invalid OTP');
        });
  }

  resendOTP() {
    this.spinner.show();
    this.authService.resendCode(this.email)
      .pipe(first())
      .subscribe(
        (userObj) => {
          this.spinner.hide();
          this.toast.display('Account activated successfully, please login');
        }, error => {
          this.spinner.hide();
          console.error('error', error);
          this.toast.error('Something went wrong, please contact Admin');
        });
  }

  get field(): any {
    return this.accountVerificationForm.controls;
  }
}
